import {createContext} from 'react'

export interface ModalContextValue {
    /** Id of the title, for aria-labelledby */
    titleId: string
    /** A ModalHeader with a title calls this while mounted, so the dialog points aria-labelledby at it */
    registerTitle: () => () => void
    /** Stack level of the Modal, a Modal rendered in it lies above it */
    level: number
}

/** Given by an open Modal to what is rendered in it (ModalHeader, a Modal opened from it) */
export const ModalContext = createContext<ModalContextValue>(null)
